import React from "react";
import { ApplicationFunctions, useAuth } from "../../contexts/authContext";

export interface AuthorizeProps {
    applicationFunction: ApplicationFunctions
    attachmentTypeId?: number
    itemTypeId?: number
    priceTypeId?: number
    projectTypeId?: number
    workflowDefinitionId?: number
    children: React.ReactNode
}

const Authorize: React.FC<AuthorizeProps> = (props: AuthorizeProps) => {
    const { isAuthorizedFor, isAuthorizedForAttachmentType, isAuthorizedForItemType, isAuthorizedForPriceType, isAuthorizedForProjectType, isAuthorizedForWorkflowDefinition } = useAuth();

    //	let children = props.children;

    if (isAuthorizedFor(props.applicationFunction) ||
        (props.attachmentTypeId && isAuthorizedForAttachmentType(props.applicationFunction, props.attachmentTypeId)) ||
        (props.itemTypeId && isAuthorizedForItemType(props.applicationFunction, props.itemTypeId)) ||
        (props.priceTypeId && isAuthorizedForPriceType(props.applicationFunction, props.priceTypeId)) ||
        (props.workflowDefinitionId && isAuthorizedForWorkflowDefinition(props.applicationFunction, props.workflowDefinitionId)) ||
        (props.projectTypeId && isAuthorizedForProjectType(props.applicationFunction, props.projectTypeId))) {

        return <>{props.children}</>
    }

    return <></>
}
export default Authorize;